import {updateCellOfColumnType} from 'notebook/structured-tables/columns/ColumnDefinitions';
import {StructuredTable} from 'notebook/structured-tables/StructuredTableConstants';
import {Cell, TableColumnType} from 'notebook/tables/TableConstants';

export function getTableWithUpdatedCellByColumnType<TTableMetadata, TRowMetadata>(
  table: StructuredTable<TTableMetadata, TRowMetadata>,
  rowIndex: number,
  columnType: TableColumnType,
  newCellValue: Cell
): StructuredTable<TTableMetadata, TRowMetadata> {
  const row = table.rows[rowIndex];
  const updatedCellsForRow = updateCellOfColumnType({
    columnDefinitionType: columnType,
    tableColumnDefinitions: table.columns.map((column) => ({type: column.columnType})),
    tableRow: row.cells,
    cellValue: newCellValue,
  });
  return {
    ...table,
    rows: [
      ...table.rows.slice(0, rowIndex),
      {...row, cells: updatedCellsForRow},
      ...table.rows.slice(rowIndex + 1, table.rows.length - 1),
    ],
  };
}
